/* 🧠 REDUX */
import { store } from "../../Redux/Store";
import { changeModal } from "../../Redux/Actions";

/* 🔧 UTILS */
import { createStep } from "./index";

// const isMobile = window.matchMedia("(max-width: 1080px)").matches;

export const historySteps = (t) => [
    createStep({
      selector: '#selects',
      stepNumber: 1,
      titleKey: t("tour.history.selects.title"),
      textKey: t("tour.history.selects.text"),
    }),
    createStep({
      selector: '#date-inputs',
      stepNumber: 2,
      titleKey: t("tour.history.date-inputs.title"),
      textKey: t("tour.history.date-inputs.text"),
    }),
    createStep({
      selector: '#download-excel',
      stepNumber: 3,
      titleKey: t("tour.history.download-excel.title"),
      textKey: t("tour.history.download-excel.text"),
    }),
    createStep({
      selector: '#download-modal',
      stepNumber: 4,
      titleKey: t("tour.history.download-modal.title"),
      textKey: t("tour.history.download-modal.text"),
    }),
    createStep({
      selector: '#general-data',
      stepNumber: 5,
      titleKey: t("tour.history.general-data.title"),
      textKey: t("tour.history.general-data.text"),
    }),
];

export const handleHistoryPrevStep = (currentStep, setCurrentStep) => {
  const stepActions = {
    3: () => {
        store.dispatch(changeModal(''));
        setCurrentStep(2);
    },
    4: () => {
        store.dispatch(changeModal('reports'));
        setCurrentStep(3);
    }
  };

  if (stepActions[currentStep]) {
      stepActions[currentStep]();
  } else {
      setCurrentStep(currentStep - 1);
  }
};

export const handleHistoryNextStep = (currentStep, setCurrentStep, setIsOpen) => {
  
  const stepActions = {
    2: () => {
      store.dispatch(changeModal('reports'));
      setCurrentStep(3);
    },
    3: () => {
      store.dispatch(changeModal(''));

      const generalData = document.querySelector('#general-data');
      if (generalData) {
        setCurrentStep(4);
      } else {
        setIsOpen(false); 
        setCurrentStep(0);
      }
    },
    4: () => {
      setIsOpen(false); 
      setCurrentStep(0); 
    }
  };

  if (stepActions[currentStep]) {
    stepActions[currentStep]();
  } else {
    setCurrentStep(currentStep + 1);
  }
};
